'use strict';

window.loadBrends = () => {
    import('./finder/inner').then(module => {
        module.loadBrands();
    });
};
